<template lang="pug">
  .requests-table
    vue-custom-scrollbar(
    class="table-wrapper"
    :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell(
            v-if="showCheckbox"
            )
              .table__cell-content
                label.checkbox
                  input(type="checkbox" v-model="select_all" @change="selectAllItem($event)")
                  .checkbox__text
            th.table__cell
              .table__cell-content Статус заявки
                .sort
            th.table__cell
              .table__cell-content Номер заявки
                .sort
            th.table__cell
              .table__cell-content Название
                .sort
            th.table__cell
              .table__cell-content Подарок
                .sort
            th.table__cell
              .table__cell-content Дата подачи
                .sort
            th.table__cell
              .table__cell-content ФИО
                .sort
            th.table__cell.fixed
              .table__cell-content

        tbody.table__body
          tr.table__row(v-for="order in orders")
            td.table__cell(
            v-if="showCheckbox"
            )
              .table__cell-content
                label.checkbox
                  input(type="checkbox" :checked="checked_(order.id)" @change="select($event, order)")
                  .checkbox__text
            td.table__cell
              .table__cell-content
                .status-marker(
                :class="order.current_status.status|classOrder"
                ) {{ order.current_status.status | statusOrder }}
            td.table__cell
              .table__cell-content
                a.table__cell-link(
                :href="setLink(order.id)"
                target="_blank"
                ) №{{ order.id }}
            td.table__cell
              .table__cell-content {{order.event.title}}
            td.table__cell
              .table__cell-content {{setGift(order.ticket_info)}}
            td.table__cell
              .table__cell-content {{ order.date_created | simpleDate }}
            td.table__cell
              .table__cell-content {{ order.user.last_name }} {{ order.user.first_name }} {{ order.user.fathers_name }}
            td.table__cell.fixed
              .table__cell-content
                .more
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "requests-table",
  // props: ["orders"],
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    vueCustomScrollbar,
  },
  watch: {
    orders() {
      this.selected = [];
      this.select_all = false;
    },
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true,
      },
      selected: [],
      select_all: false,
    };
  },
  computed: {},
  methods: {
    checked_(id) {
      return (
        this.selected.filter((i) => {
          return i.id === id;
        }).length > 0
      );
    },
    select(event, order) {
      if (event.target.checked) {
        this.selected.push({
          id: order.id,
          status: order.current_status.status,
        });
      } else {
        this.selected = this.selected.filter((i) => {
          return i.id !== order.id;
        });
      }
      this.$emit("change", this.selected);
    },
    selectAllItem(event) {
      if (event.target.checked) {
        this.$props.orders.forEach((i) => {
          if (
            this.selected.filter((item) => {
              return i.id === item.id;
            }).length === 0
          ) {
            this.selected.push({
              id: i.id,
              status: i.current_status.status,
            });
          }
        });
      } else {
        this.selected = [];
      }
      this.$emit("change", this.selected);
    },
    setLink(id) {
      let path = this.$route.path;
      let lastSymbol = path[path.length - 1];
      if (lastSymbol !== "/") {
        path = path + "/";
      }
      return path + id;
    },
    setGift(ticket) {
      if (ticket && ticket.option_1_activated) {
        return "Получен";
      } else {
        return "Не получен";
      }
    },
  },
};
</script>
